import React, { useEffect, useState, useRef, useCallback } from "react";
import Input from "../../components/controls/input/customInput/CustomInput";
import DropDown from "../../components/controls/dropdown/DropdownFluent";
import InputUnderline from "../../components/controls/input/InputUnderline";
import { CalendarIcon } from "../../modules/default-svg";
import Searchable from "../../components/controls/select/CustomSelect";
import {
  calculatePageSize,
  changeRequestPriorities,
  getLabelByType,
  ScopeStatus,
} from "../../helpers/utils";
import service from "../../store/services/user.service";
import scopeService from "../../store/services/scope.service";
import clientService from "../../store/services/clients.service";
import portfolioService from "../../store/services/portfolio.service";
import programService from "../../store/services/programs.service";
import projectService from "../../store/services/projects.service";
import ModalCheckbox from "../../components/controls/modalcheckbox/ModalCheckbox";
import {
  AvatarGroup,
  AvatarGroupItem,
  AvatarGroupPopover,
  partitionAvatarGroupItems,
} from "@fluentui/react-components";
import { apiCall } from "../../store/services/service";
import {
  BASE_URL,
  URL_SEARCH_CLIENT_PORTFOLIO,
} from "../../store/services/URL";
import { ColumnConfigProvider } from "../../components/controls/tables/ColumnConfigProvider";
import Table from "../../components/controls/tables/Table";
import RichTextEditor from "../../components/richTextEditor/RichTextEditor";
import AssociatedRisks from "../risk/AssociatedRisks";
import EntityFileUpload from "../../components/controls/fileUpload/EntityFileUpload";
import { isDateGreaterThan } from "../../utils/systemSettings";
import DateRangeWithDuration from "../../components/dateRangeWithDuration/DateRangeWithDuration";
import { TABLE_ACTIONS } from "../../components/controls/tables/utils/tableUtils";
import { get } from "jquery";

const ScopeItem = (props) => {
  const {
    portfolioID,
    projectID,
    programID,
    defaultProject,
    defaultProgram,
    defaultPortfolio,
    allScopeItems,
    pageLoading,
    loading,
    pagination,
    getScopeItemsRequest,
    createScopeRequest,
    updateScopeRequest,
    deleteScopeRequest,
    duplicateScopeRequest,
    duplicateTaskRequest,
    getProjectProgressSummary,
    getProgramProgressSummary,
    getPortFolioProgressSummary,
    overviewType,
    error,
  } = props;
  const prevClientId = useRef(null);
  const manualUpdate = useRef({
    client: false,
    portfolio: false,
    program: false,
  });
  const [data, setData] = useState([]);
  const [perPageItems] = useState(calculatePageSize());
  const [pageNum, setPageNum] = useState(1);
  const [selectedRow, setSelectedRow] = useState({});
  const [scopeName, setScopeName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [revisedEndDate, setRevisedEndDate] = useState("");
  const [priority, setPriority] = useState("");
  const [budget, setBudget] = useState("");
  const [phase, setPhase] = useState("");
  const [status, setStatus] = useState(0);
  const [refId, setRefId] = useState("");
  const [description, setDescription] = useState("");
  const [isCreate, setIsCreate] = useState(false);
  const [ClientId, setClientId] = useState("");
  const [PortfolioId, setPortfolioId] = useState(portfolioID);
  const [ProgramId, setProgramId] = useState(programID);
  const [ProjectId, setProjectId] = useState(projectID);
  const [clientOptions, setClientOptions] = useState([]);
  const [portfolioOptions, setPortfolioOptions] = useState([]);
  const [programOptions, setProgramOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [parentType, setParentType] = useState("Scope");
  const [isHeader, setIsHeader] = useState(true);
  const [isMilestone, setIsMilestone] = useState(false);
  const [progress, setProgress] = useState(0);
  const [risks, setRisks] = useState([]);
  const [formErrors, setFormErrors] = useState({
    scopeName: "",
    startDate: "",
    endDate: "",
    revisedEndDate: "",
    projectId: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isCreateNewRow, setIsCreateNewRow] = useState(false);
  const [deleteId, setDeletedId] = useState(null);
  const [attachments, setAttachments] = useState([]);
  const [tableSearch, setTableSearch] = useState(null);
  
  const fetchData = (pageNumber, pageSize, searchTerm, forceClearSearch=false) => {
    const payload = { page: pageNumber ?? pageNum, size: pageSize ?? perPageItems, search: forceClearSearch ? null : (searchTerm ?? tableSearch) };
    payload.parent = parentType;

    if (portfolioID) {
      payload.id = portfolioID;
      payload.parent = "Portfolio";
    }

    if (programID) {
      payload.id = programID;
      payload.parent = "Program";
    }

    if (projectID) {
      payload.id = projectID;
      payload.parent = "Project";
    }
    getScopeItemsRequest(payload);
  };

  const searchClientHandler = (value) => {
    if (value === "") {
      setClientOptions([]);
      return;
    }
    clientService
      .searchClientsRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setClientOptions(transformedArray);
      })
      .catch(() => {
        setClientOptions([]);
      });
  };

  const searchPortfolioHandler = (value) => {
    if (value === "") {
      setPortfolioOptions([]);
      return;
    }
    const payload = { id: ClientId?.value, searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    if (ClientId)
      queryParam = `?clientId=${payload.id}&searchTerm=${payload.searchText}`;
    apiCall
      .get({
        url: `${URL_SEARCH_CLIENT_PORTFOLIO}${queryParam}`,
        isAuthToken: true,
      })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setPortfolioOptions(transformedArray);
      })
      .catch(() => {
        setPortfolioOptions([]);
      });
  };

  const searchProgramHandler = (value) => {
    if (value === "") {
      setProgramOptions([]);
      return;
    }
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;

    payload.parent = "Scope";

    if (ClientId) {
      queryParam = `?clientId=${ClientId?.value}&searchTerm=${payload.searchText}`;
    }

    if (PortfolioId) {
      queryParam = `?portfolioId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    if (portfolioID) {
      queryParam = `?portfolioId=${portfolioID}&searchTerm=${payload.searchText}`;
    }

    if (ClientId && PortfolioId) {
      queryParam = `?clientId=${ClientId.value}&portfolioId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    apiCall
      .get({ url: `${BASE_URL}search/Programs${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setProgramOptions(transformedArray);
      })
      .catch(() => {
        setProgramOptions([]);
      });
  };

  const searchProjectHandler = (value) => {
    if (value === "") {
      setProjectOptions([]);
      return;
    }
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    payload.parent = "Scope";

    if (ClientId) {
      queryParam = `?clientId=${ClientId?.value}&searchTerm=${payload.searchText}`;
    }

    if (PortfolioId) {
      queryParam = `?portfolioId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    if (portfolioID) {
      queryParam = `?portfolioId=${portfolioID}&searchTerm=${payload.searchText}`;
    }

    if (ProgramId) {
      queryParam = `?programId=${ProgramId.value}&searchTerm=${payload.searchText}`;
    }

    if (ClientId && PortfolioId) {
      queryParam = `?clientId=${ClientId.value}&portfolioId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    if (ClientId && ProgramId) {
      queryParam = `?clientId=${ClientId.value}&programId=${ProgramId.value}&searchTerm=${payload.searchText}`;
    }

    if (PortfolioId && ProgramId) {
      queryParam = `?portfolioId=${PortfolioId.value}&programId=${ProgramId.value}&searchTerm=${payload.searchText}`;
    }

    if (ClientId && PortfolioId && ProgramId) {
      queryParam = `?clientId=${ClientId.value}&portfolioId=${PortfolioId.value}&programId=${ProgramId.value}&searchTerm=${payload.searchText}`;
    }

    apiCall
      .get({ url: `${BASE_URL}search/Projects${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          start: obj.startDate,
          end: obj.endDate,
          label: obj.name,
          value: obj.id,
        }));
        setProjectOptions(transformedArray);
      })
      .catch(() => {
        setProjectOptions([]);
      });
  };

  const getRequestPriority = (type) => {
    switch (type) {
      case 0:
        return "Low";
      case 1:
        return "Moderate";
      case 2:
        return "High";
      default:
        return "";
    }
  };

  const setRequestPriority = (type) => {
    switch (type) {
      case "Low":
        return 0;
      case "Moderate":
        return 1;
      case "High":
        return 2;
      default:
        return 0;
    }
  };

  useEffect(() => {
    fetchData();
  }, [pageNum, perPageItems]);

  const handleCancelAddRow = () => {
    setIsCreateNewRow(false);
    fetchData();
  };

  const handleSave = () => {
    if (!isDisable) {
      if (!budget) setBudget(null);
      const errors = {};
      if (startDate && endDate && isDateGreaterThan(startDate, endDate)) {
        errors[
          "endDate"
        ] = `End date must be equal to or greater than start date.`;
      }
      if (
        startDate &&
        revisedEndDate &&
        isDateGreaterThan(startDate, revisedEndDate)
      ) {
        errors[
          "revisedEndDate"
        ] = `Revised end date must be equal to or greater than start date.`;
      }
      if (!scopeName) errors["scopeName"] = `The Name field is required.`;
      if (!projectID) {
        if (!ProjectId) errors["projectId"] = `The Project field is required.`;
      }

      setFormErrors(errors);
      if (Object.keys(errors).length) {
        return;
      }
      const payload = {
        Name: scopeName,
        ProjectId: projectID ? projectID : ProjectId?.value,
        StartDate: startDate ? startDate : null,
        EndDate: endDate ? endDate : null,
        RevisedEndDate: revisedEndDate ? revisedEndDate : null,
        Priority: setRequestPriority(priority),
        Budget: budget ? budget : 0,
        Phase: phase,
        Status: status,
        RefId: refId,
        Description: description,
        IsMilestone: isMilestone,
      };
      if (Object.keys(selectedRow).length > 0) {
        if (projectID) {
          updateScopeRequest({
            sId: selectedRow.id,
            parentID: projectID,
            parent: "Project",
            payload,
          });
          return;
        }
        if (programID) {
          updateScopeRequest({
            sId: selectedRow.id,
            parentID: programID,
            parent: "Program",
            payload,
          });
          return;
        }
        if (portfolioID) {
          updateScopeRequest({
            sId: selectedRow.id,
            parentID: portfolioID,
            parent: "Portfolio",
            payload,
          });
          return;
        }

        updateScopeRequest({ sId: selectedRow.id, parent: "Scope", payload });
      } else {
        if (projectID) {
          createScopeRequest({
            parentID: projectID,
            parent: "Project",
            payload,
          });
          return;
        }
        if (programID) {
          createScopeRequest({
            parentID: programID,
            parent: "Program",
            payload,
          });
          return;
        }
        if (portfolioID) {
          createScopeRequest({
            parentID: portfolioID,
            parent: "Portfolio",
            payload,
          });
          return;
        }

        createScopeRequest({ parent: "Scope", payload });
      }
    }
  };

  const fetchScopeData = async () => {
    setIsLoading(true);
    scopeService
      .getScopeDetailsRequest({ id: selectedRow.id })
      .then((scopeData) => {
        setScopeName(scopeData.name);
        setStartDate(scopeData.startDate);
        setEndDate(scopeData.endDate);
        setRevisedEndDate(scopeData.revisedEndDate);
        setPriority(getRequestPriority(scopeData.priority));
        setBudget(scopeData.budget);
        setPhase(scopeData.phase);
        setStatus(scopeData.status);
        setRefId(scopeData.refId);
        setDescription(scopeData.description);
        setProgress(scopeData.progress);
        setIsMilestone(scopeData.isMilestone);
        scopeData.client
          ? setClientId({
              label: scopeData.client.name,
              value: scopeData.client.id,
            })
          : setClientId("");
        scopeData.portfolio
          ? setPortfolioId({
              label: scopeData.portfolio.name,
              value: scopeData.portfolio.id,
            })
          : setPortfolioId("");
        scopeData.program
          ? setProgramId({
              label: scopeData.program.name,
              value: scopeData.program.id,
            })
          : setProgramId("");
        scopeData.project
          ? setProjectId({
              label: scopeData.project.name,
              value: scopeData.project.id,
            })
          : setProjectId("");
        setRisks(scopeData.risks);
        setAttachments(scopeData.attachments || []);
        setIsLoading(false);
      })
      .catch((error) => console.error("Error fetching data:", error));
  };

  useEffect(() => {
    if (Object.keys(selectedRow).length > 0) {
      isEdit && fetchScopeData();
    } else {
      setClientId("");
      setPortfolioId("");
      setProgramId("");
      setProjectId("");
      setScopeName("");
      setStartDate("");
      setEndDate("");
      setRevisedEndDate("");
      setPriority("");
      setBudget("");
      setPhase("");
      setStatus(0);
      setRefId("");
      setDescription("");
      setIsMilestone(false);
      setRisks([]);
      setAttachments([]);
    }
  }, [selectedRow, isEdit]);

  const handleDelete = (selectedRow) => {
    if (!isDisable) {
      // const id = JSON.parse(localStorage.getItem("selectedRow")).id;
      const id = selectedRow.id;
      if (projectID) {
        deleteScopeRequest({ sId: id, parentID: projectID, parent: "Project" });
        return;
      }
      if (programID) {
        deleteScopeRequest({ sId: id, parentID: programID, parent: "Program" });
        return;
      }
      if (portfolioID) {
        deleteScopeRequest({
          sId: id,
          parentID: portfolioID,
          parent: "PortFolio",
        });
        return;
      }

      deleteScopeRequest({ sId: id, parent: "Scope" });
      setDeletedId(id);
      // localStorage.removeItem("selectedRow");
    }
  };

  const handleCancel = () => {
    setFormErrors({});
    setIsEdit(false);
    setIsMilestone(false);
  };

  const handleInputChange = (value, name) => {
    if (name === "startDate") setStartDate(value);
    if (name === "endDate") setEndDate(value);
    if (name === "revisedEndDate") setRevisedEndDate(value);
    if (name === "scopeName") {
      setScopeName(value);
      if (formErrors && value) {
        setFormErrors({
          ...formErrors,
          [name]: "",
        });
      }
    }
  };

  useEffect(() => {
    if (error !== "" && error) {
      Object.keys(error).forEach((key) => {
        if (key === "Name") {
          setFormErrors((prevErrors) => ({
            ...prevErrors,
            scopeName: error[key][0],
          }));
        }
      });
    }
  }, [error]);

  useEffect(() => {
    if (allScopeItems && allScopeItems.length > 0) {
      if (isCreateNewRow) {
        setData(
          allScopeItems.sort((a, b) => {
            return b.isFlagged - a.isFlagged;
          })
        );
        setIsCreateNewRow(false);
      } else {
        if (pageNum === 1) {
          setData(
            allScopeItems
              .filter((item) => item.id !== deleteId)
              .sort((a, b) => {
                return b.isFlagged - a.isFlagged;
              })
          );
        } else {
          setData((prevData) => {
            const newMap = new Map(
              allScopeItems.map((scope) => [scope.id, scope])
            );

            const updatedPrevData = prevData.map((item) =>
              newMap.has(item.id) ? newMap.get(item.id) : item
            );

            const prevDataIds = new Set(prevData.map((item) => item.id));
            const newItems = allScopeItems.filter(
              (shift) => !prevDataIds.has(shift.id)
            );

            return [...updatedPrevData, ...newItems]
              .filter((item) => item.id !== deleteId)
              .sort((a, b) => b.isFlagged - a.isFlagged);
          });
        }
      }
    } else if (allScopeItems && allScopeItems.length === 0 && pageNum === 1) {
      setData([]);
      setIsEdit(false);
      setSelectedRow({});
    }
  }, [allScopeItems]);

  const handleAddRow = useCallback(() => {
    setIsCreateNewRow(true);
    fetchData(pagination.TotalPages ?? 1, perPageItems > 10 ? perPageItems - 5 : perPageItems - 3);
  }, []);

  const handleSearch = (filteredData) => {
    setData(filteredData);
  };

  const formBody = () => {
    return (
      <div>
        <div className="d-flex align-items-end justify-content-between">
          <div className={isEdit ? "col-10" : "col-12"}>
            <InputUnderline
              placeholder="Add scope name"
              value={scopeName}
              error={formErrors.scopeName}
              handleChange={(value) => handleInputChange(value, "scopeName")}
              isRequired
              loading={isLoading}
            />
          </div>
          {isEdit && (
            <div className="col-1 ml-2">
              <label class="Input_label">Progress</label>
              <p
                style={{ border: "1px solid #342C82" }}
                className="text-xs text-[#1F1F1F] font-semibold bg-[#EDECF8] text-center py-[4px] rounded-md"
              >
                {`${progress} %`}
              </p>
            </div>
          )}
        </div>
        <div className="mt-3 mb-2 w-25">
          <ModalCheckbox
            label={isMilestone ? "Milestone" : "Mark as Milestone"}
            checked={isMilestone}
            setChecked={setIsMilestone}
          />
        </div>
        {isEdit && <AssociatedRisks isLoading={isLoading} risks={risks} />}
        <div className="row gx-3 mb-3">
          {overviewType !== "Portfolio" &&
            overviewType !== "Program" &&
            overviewType !== "Project" && (
              <div className="col mt-4 w-100">
                <Searchable
                  label="Client"
                  SelectText="client"
                  searchText={searchClientHandler}
                  options={clientOptions}
                  defaultVal={ClientId}
                  onChange={(e) => {
                    setClientId(e);
                    setPortfolioId("");
                    setProgramId("");
                    setProjectId("");
                  }}
                  loading={isLoading}
                />
              </div>
            )}
          {overviewType !== "Portfolio" &&
            overviewType !== "Program" &&
            overviewType !== "Project" && (
              <div className="col mt-4 w-100">
                <Searchable
                  label="Portfolio"
                  SelectText="portfolio"
                  searchText={searchPortfolioHandler}
                  options={portfolioOptions}
                  defaultVal={PortfolioId}
                  onChange={(e) => {
                    setPortfolioId(e);
                    setProgramId("");
                    setProjectId("");
                  }}
                  loading={isLoading}
                />
              </div>
            )}
        </div>
        <div className="row gx-3 mb-3">
          {overviewType !== "Program" && overviewType !== "Project" && (
            <div className="col mt-4 w-100">
              <Searchable
                label="Program"
                SelectText="program"
                searchText={searchProgramHandler}
                options={programOptions}
                defaultVal={ProgramId}
                onChange={(e) => {
                  setProgramId(e);
                  setProjectId("");
                }}
                loading={isLoading}
              />
            </div>
          )}
          {overviewType !== "Project" && (
            <div className="col mt-4 w-100">
              <Searchable
                label="Project"
                SelectText="project"
                searchText={searchProjectHandler}
                options={projectOptions}
                defaultVal={ProjectId}
                onChange={(e) => setProjectId(e)}
                errorMessage={formErrors.projectId}
                isRequired
                loading={isLoading}
              />
            </div>
          )}
        </div>
        <div className="row align-items-center gx-3 mb-3">
          <DateRangeWithDuration
            startDate={startDate}
            endDate={endDate}
            revisedEndDate={revisedEndDate}
            onStartDateChange={(value) => handleInputChange(value, "startDate")}
            onEndDateChange={(value) => handleInputChange(value, "endDate")}
            onRevisedEndDateChange={(value) => handleInputChange(value, "revisedEndDate")}
            startDateError={formErrors.startDate}
            endDateError={formErrors.endDate}
            showRevisedEndDate={true}
            icon={<CalendarIcon />}
            isLoading={isLoading}
          />
        </div>
        <div className="row align-items-center gx-3 mb-3">
          <div className="col-4">
            <DropDown
              label="Status"
              options={ScopeStatus}
              defaultVal={getLabelByType("scope", status)}
              onChange={setStatus}
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <DropDown
              label="Priority"
              options={changeRequestPriorities}
              defaultVal={priority}
              onChange={setPriority}
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={false}
              // placeholder={`${getAccountCurrency(setting)} 0`}
              value={budget}
              type="number"
              currency={true}
              placeholder="0"
              handleChange={setBudget}
              label="Budget"
              loading={isLoading}
            />
          </div>
        </div>
        <div className="row align-items-center gx-3 mb-3">
          <div className="col-4">
            <Input
              icon={false}
              placeholder="Enter phase"
              value={phase}
              type="text"
              handleChange={setPhase}
              label="Phase"
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={false}
              placeholder="Enter Reference ID"
              value={refId}
              type="text"
              handleChange={setRefId}
              label="Reference ID"
              loading={isLoading}
            />
          </div>
        </div>
        <div className="mb-3">
          <RichTextEditor
            label="Description"
            content={description}
            onChange={setDescription}
            loading={isLoading}
          />
        </div>
        <EntityFileUpload
          entityId={selectedRow.id}
          entityType="Scope"
          attachments={attachments}
          onAttachmentsChange={() => {
            if (selectedRow.id) {
              scopeService
                .getScopeDetailsRequest({ id: selectedRow.id })
                .then((scopeData) => {
                  setAttachments(scopeData.attachments);
                })
                .catch((error) => {
                  console.error("Error fetching scope data:", error);
                });
            }
          }}
          disabled={isLoading || !selectedRow.id}
        />
      </div>
    );
  };

  useEffect(() => {
    if (scopeName) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        scopeName: "",
      }));
    }
    if (ProjectId) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        projectId: "",
      }));
    }
  }, [ProjectId, scopeName]);

  useEffect(() => {
    if (projectID) {
      setParentType("Project");
      setIsHeader(false);
    }
    if (programID) {
      setParentType("Program");
      setIsHeader(false);
    }
    if (portfolioID) {
      setParentType("Portfolio");
      setIsHeader(false);
    }
  }, [projectID, programID, portfolioID, parentType]);

  useEffect(() => {
    if (defaultProject && defaultProject.hasOwnProperty("name")) {
      setProjectId({
        label: defaultProject.name,
        value: defaultProject.id,
      });
    }
  }, [defaultProject]);

  useEffect(() => {
    if (defaultProgram && defaultProgram.hasOwnProperty("name")) {
      setProgramId({
        label: defaultProgram.name,
        value: defaultProgram.id,
      });
    }
  }, [defaultProgram]);

  useEffect(() => {
    if (defaultPortfolio && defaultPortfolio.hasOwnProperty("name")) {
      setPortfolioId({
        label: defaultPortfolio.name,
        value: defaultPortfolio.id,
      });
    }
  }, [defaultPortfolio]);

  useEffect(() => {
    if (ProjectId && !manualUpdate.current.program) {
      if (!ClientId && !PortfolioId && !ProgramId && !projectID) {
        projectService
          .getProjectDetailsRequest({ id: ProjectId.value })
          .then((projectData) => {
            // Mark the next updates as manual to prevent cascading effects
            manualUpdate.current.program = true;
            manualUpdate.current.portfolio = true;
            manualUpdate.current.client = true;

            // Update the state of the parent fields
            projectData.client
              ? setClientId({
                  label: projectData.client.name,
                  value: projectData.client.id,
                })
              : setClientId("");
            projectData.portfolio
              ? setPortfolioId({
                  label: projectData.portfolio.name,
                  value: projectData.portfolio.id,
                })
              : setPortfolioId("");
            projectData.program
              ? setProgramId({
                  label: projectData.program.name,
                  value: projectData.program.id,
                })
              : setProgramId("");
          })
          .catch((error) =>
            console.error("Error fetching project data:", error)
          );
      }
    }
  }, [ProjectId]);

  useEffect(() => {
    if (!ProgramId) {
      setProjectId("");
    }
    if (ProgramId && !manualUpdate.current.portfolio) {
      if (!ClientId && !PortfolioId) {
        programService
          .fetchProgramDataRequest({
            id: typeof ProgramId === "string" ? ProgramId : ProgramId.value,
          })
          .then((data) => {
            // Mark the next updates as manual to prevent cascading effects
            manualUpdate.current.portfolio = true;
            manualUpdate.current.client = true;

            // Update the state of the parent fields
            data.client
              ? setClientId({ label: data.client.name, value: data.client.id })
              : setClientId("");
            data.portfolio
              ? setPortfolioId({
                  label: data.portfolio.name,
                  value: data.portfolio.id,
                })
              : setPortfolioId("");
            setProjectId(""); // Clear ProjectId when ProgramId changes
          })
          .catch((error) =>
            console.error("Error fetching program data:", error)
          );
      } else {
        if (!isEdit) {
          setProjectId("");
        }
      }
    }
  }, [ProgramId]);

  useEffect(() => {
    if (!PortfolioId) {
      setProgramId("");
      setProjectId("");
    }
    if (PortfolioId && !manualUpdate.current.client) {
      if (!ClientId) {
        portfolioService
          .getPortfolioDetails({
            id:
              typeof PortfolioId === "string" ? PortfolioId : PortfolioId.value,
          })
          .then((portfolioData) => {
            manualUpdate.current.client = true;
            portfolioData.client
              ? setClientId({
                  label: portfolioData.client.name,
                  value: portfolioData.client.id,
                })
              : setClientId("");
            setProgramId("");
            setProjectId("");
          })
          .catch((error) =>
            console.error("Error fetching portfolio data:", error)
          );
      } else {
        if (!isEdit) {
          setProgramId("");
          setProjectId("");
        }
      }
    }
  }, [PortfolioId]);

  useEffect(() => {
    if (!ClientId) {
      setPortfolioId("");
      setProgramId("");
      setProjectId("");
    }
    if (ClientId) {
      prevClientId.current = ClientId.value;
    }
    // if (ClientId && prevClientId.current === null) {
    //   prevClientId.current = ClientId.value;
    // }
    if (ClientId && prevClientId.current !== ClientId.value) {
      setPortfolioId("");
      setProgramId("");
      setProjectId("");
      prevClientId.current = ClientId.value;
    }
    manualUpdate.current.client = false;
    manualUpdate.current.portfolio = false;
    manualUpdate.current.program = false;
  }, [ClientId]);

  const [isDisable, setIsDisable] = useState(false);

  useEffect(() => {
    if (loading) setIsDisable(true);
    else setIsDisable(false);
  }, [loading]);

  const handleSearchTrigger = (searchTerm) => {
    if((!tableSearch && !searchTerm) || (tableSearch === searchTerm)) return;

    let pageNumber = pageNum;
    if(!tableSearch || (tableSearch && !searchTerm) || (tableSearch !== searchTerm)){
      setData([]); //clear existing data
      pageNumber = 1; //reset to first page
    }
      
    setTableSearch(searchTerm);
    fetchData(pageNumber, perPageItems, searchTerm, !searchTerm);
  };

  const refreshParentProgressSummary = () => {
    if (portfolioID) {
      getPortFolioProgressSummary({ id: portfolioID});
    }

    if (programID) {
      getProgramProgressSummary({id: programID});
    }

    if (projectID) {
      getProjectProgressSummary({id: projectID});
    }
  };

  const handleScopeActionCallback = () => {
    fetchData(1, perPageItems);
    refreshParentProgressSummary();
  };

  const handleDuplicate = (props) => {
      if(props.payload.id){
        duplicateScopeRequest(
          { 
            id: props.payload.id, 
            payload: {
              isIncludeTasks: props.payload.isIncludeTasks
            },
            callback: handleScopeActionCallback
          }
        );  
      }
  }

  const handleTableAction = (props) => {
 
    switch (props.actionType) {
      case TABLE_ACTIONS.DUPLICATE:
        handleDuplicate(props);
        break;
     
    }
  }

  return (
    <ColumnConfigProvider
      tableName={parentType === "Scope" ? "Scope" : `${parentType}-Scope`}
    >
      <div className="listingScreen position-relative">
        <Table
          type="Scope"
          isHeader={isHeader}
          parentType={parentType}
          rows={data || []}
          searchHandler={handleSearch}
          body={formBody()}
          saveBtnLabel="Save"
          cancelBtnLabel="Cancel"
          setPageNum={setPageNum}
          perPageItems={perPageItems}
          setIsCreate={setIsCreate}
          handleSave={() => handleSave()}
          handleDelete={(selectedRow) => handleDelete(selectedRow)}
          handleCancel={() => handleCancel()}
          setIsEdit={setIsEdit}
          loading={pageLoading}
          modalLoading={loading}
          isCreate={isCreate}
          pagination={pagination}
          setSelectedRow={setSelectedRow}
          projectId={projectID}
          programId={programID}
          portfolioId={portfolioID}
          handleAddRow={handleAddRow}
          handleCancelAddRow={handleCancelAddRow}
          setData={setData}
          triggerSearch={handleSearchTrigger}
          handleAction={handleTableAction}
        />
      </div>
    </ColumnConfigProvider>
  );
};
export default ScopeItem;
